// whitelabel brands
const whitelabelConfig = {
  SRAX: {
    name: 'SRAX',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/mysequire/logo-main-light.svg',
      loginDark: '/static/mysequire/logo-main-dark.svg',
      header: '/static/mysequire/logo-main-light.svg',
      headerDark: '/static/mysequire/logo-main-dark.svg',
    },
    originList: [
      'http://localhost:8080',
      'http://local.mysequire.com:8080',
      'https://platform-lab.mysequire.com',
      'https://platform-stage.mysequire.com',
      'https://platform.mysequire.com',
    ],
  },
  EQUITYSTOCKTRANSFER: {
    name: 'Equity Stock Transfer',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/equity_stock_transfer/login-logo.png',
      header: '/static/equity_stock_transfer/header-logo.png',
    },
    originList: [
      'https://equitystock.mysequire.com',
      'https://equitystock-stage.mysequire.com',
    ],
  },
  VIPVENTURES: {
    name: 'VIP VENTURES LIMITED LLC.',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/vip_ventures/login-logo.png',
      header: '/static/vip_ventures/header-logo.png',
    },
    originList: [
      'https://vipventuresltd.mysequire.com',
      'https://vipventuresltd-stage.mysequire.com',
    ],
  },
  EMPIRESTOCK: {
    name: 'Empire Stock Transfer Inc.',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/empire_stock/login-logo.png',
      header: '/static/empire_stock/header-logo.png',
    },
    originList: [
      'https://empirestock.mysequire.com',
      'https://empirestock-stage.mysequire.com',
    ],
  },
  XTRATEGY: {
    name: 'X-trategy Consulting Team',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/x_trategy/login-logo.png',
      header: '/static/x_trategy/header-logo.png',
    },
    originList: [
      'https://x-trategyir.mysequire.com',
      'https://x-trategyir-stage.mysequire.com',
    ],
  },
  ALPHADIRECT: {
    name: 'Alpha Direct',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/alpha_direct/login-logo.png',
      header: '/static/alpha_direct/header-logo.png',
    },
    originList: [
      'https://alphadirect.mysequire.com',
      'https://alphadirect-stage.mysequire.com',
    ],
  },
  MZGROUP: {
    name: 'MZ Group',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/mz_group/login-logo.png',
      header: '/static/mz_group/header-logo.png',
    },
    originList: [
      'https://mzgroup.mysequire.com',
      'https://mzgroup-stage.mysequire.com',
    ],
  },
  THEMONEYCHANNEL: {
    name: 'The Money Channel',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/the_money_channel/login-logo.png',
      header: '/static/the_money_channel/header-logo.png',
    },
    originList: [
      'https://themoneychannel.mysequire.com',
      'https://themoneychannel-stage.mysequire.com',
    ],
  },
  LHA: {
    name: 'LHA',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/lha/login-logo.png',
      header: '/static/lha/header-logo.png',
    },
    originList: [
      'https://lha.mysequire.com',
      'https://lha-stage.mysequire.com',
    ],
  },
  INTEGROUSCAPITALPARTNERS: {
    name: 'Integrous Capital Partners',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/integrous_capital_partners/login-logo.png',
      header: '/static/integrous_capital_partners/header-logo.png',
    },
    originList: [
      'https://integrouscapitalpartners.mysequire.com',
      'https://integrouscapitalpartners-stage.mysequire.com',
    ],
  },
  HAYDENIR: {
    name: 'Hayden IR',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/hayden_ir/login-logo.png',
      header: '/static/hayden_ir/header-logo.png',
    },
    originList: [
      'https://haydenir.mysequire.com',
      'https://haydenir-stage.mysequire.com',
    ],
  },
  AJS: {
    name: 'AJS Management Corp',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/ajs/login-logo.png',
      header: '/static/ajs/header-logo.png',
    },
    originList: [
      'https://ajs.mysequire.com',
      'https://ajs-stage.mysequire.com',
    ],
  },
  IBN: {
    name: 'Investor Brand Network',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/ibn/login-logo.png',
      header: '/static/ibn/header-logo.png',
    },
    originList: [
      'https://ibn.mysequire.com',
      'https://ibn-stage.mysequire.com',
    ],
  },
  BROADRIDGE: {
    name: 'Broadridge',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/broadridge/login-logo.png',
      header: '/static/broadridge/header-logo.png',
    },
    originList: [
      'https://broadridge.mysequire.com',
      'https://broadridge-stage.mysequire.com',
    ],
  },
  BRILEYFBR: {
    name: 'Brileyfbr',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/brileyfbr/login-logo.png',
      header: '/static/brileyfbr/header-logo.png',
    },
    originList: [
      'https://brileyfbr.mysequire.com',
      'https://brileyfbr-stage.mysequire.com',
    ],
  },
  PETRUSIR: {
    name: 'Petrus Capital Holdings, Inc',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/petrusir/login-logo.png',
      header: '/static/petrusir/header-logo.png',
    },
    originList: [
      'https://petrusir.mysequire.com',
      'https://petrusir-stage.mysequire.com',
    ],
  },
  M2COMPLIANCE: {
    name: 'M2 Compliance',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/m2compliance/login-logo.png',
      header: '/static/m2compliance/header-logo.png',
    },
    originList: [
      'https://m2compliance.mysequire.com',
      'https://m2compliance-stage.mysequire.com',
    ],
  },
  AVENELFINANCIAL: {
    name: 'Avenel Financial Group, Inc.',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/avenel_financial/login-logo.png',
      header: '/static/avenel_financial/header-logo.png',
    },
    originList: [
      'https://avenelfinancial.mysequire.com',
      'https://avenelfinancial-stage.mysequire.com',
    ],
  },
  DGIPL: {
    name: 'Dragon Gate Investment Partners',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/dgipl/login-logo.png',
      header: '/static/dgipl/header-logo.png',
    },
    originList: [
      'https://dgipl.mysequire.com',
      'https://dgipl-stage.mysequire.com',
    ],
  },
  WALLSTREETRESOURCE: {
    name: 'Wall Street Resource',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/wall_street_resource/login-logo.png',
      header: '/static/wall_street_resource/header-logo.png',
    },
    originList: [
      'https://wallstreetresource.mysequire.com',
      'https://wallstreetresource-stage.mysequire.com',
    ],
  },
  TDMFINANCIAL: {
    name: 'TDM Financial',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/tdm_financial/login-logo.png',
      header: '/static/tdm_financial/header-logo.png',
    },
    originList: [
      'https://tdmfinancial-stage.mysequire.com',
      'https://tdmfinancial.mysequire.com',
    ],
  },
  NOBLECAPITALMARKETS: {
    name: 'Noble Capital Markets',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/noble_capital_markets/login-logo.png',
      header: '/static/noble_capital_markets/header-logo.png',
    },
    originList: [
      'https://noblecapitalmarkets-stage.mysequire.com',
      'https://noblecapitalmarkets.mysequire.com',
    ],
  },
  VXGLOBAL: {
    name: 'VX Global Inc.',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/vx_global/login-logo.png',
      header: '/static/vx_global/header-logo.png',
    },
    originList: [
      'https://vxglobal-stage.mysequire.com',
      'https://vxglobal.mysequire.com/',
    ],
  },
  EURASIANCAPITAL: {
    name: ' Eurasian Capital, LLC',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/eurasian_capital/login-logo.png',
      header: '/static/eurasian_capital/header-logo.png',
    },
    originList: [
      'https://eurasiancapital-stage.mysequire.com',
      'https://eurasiancapital.mysequire.com',
    ],
  },
  TRENDINGEQUITIES: {
    name: 'Trending Equities',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/trending_equities/login-logo.png',
      header: '/static/trending_equities/header-logo.png',
    },
    originList: [
      'https://trendingequities-stage.mysequire.com',
      'https://trendingequities.mysequire.com',
    ],
  },
  STOCKMARKETMANAGER: {
    name: 'Stock Market Manager',
    homeURL: 'https://mysequire.com/',
    logoList: {
      login: '/static/stock_market_manager/login-logo.png',
      header: '/static/stock_market_manager/header-logo.png',
    },
    originList: [
      'https://stockmarketmanager-stage.mysequire.com',
      'https://stockmarketmanager.mysequire.com',
    ],
  },
};

// function to set brand
export const getBrand = function getBrand() {
  const origin = window.location.origin;
  try {
    let subdomain = origin.split('.')[0];
    if (origin !== subdomain) {
      subdomain = `${subdomain}.`;
    }

    const whitelabelKeys = Object.keys(whitelabelConfig);
    for (let i = 0; i < whitelabelKeys.length; i += 1) {
      const label = whitelabelConfig[whitelabelKeys[i]]
        .originList.find((a) => a.includes(subdomain));

      if (label) {
        return whitelabelConfig[whitelabelKeys[i]];
      }
    }
  } catch (e) {
    console.log(e);
    throw e;
  }

  return whitelabelConfig.SRAX;
};

export default {
  getBrand,
};
